<script setup lang="ts">
import LeTopBanner from "@dsk/components/LeTopBanner.vue";

/* eslint-disable @intlify/vue-i18n/no-raw-text */
</script>

<template>
  <LeTopBanner type="neutral">
    <span class="le-exam-banner__bold">VIGTIG OPDATERING</span>
    inden prøven i retskrivning. Er du lærer, og har du ordblinde elever?
    <a
      href="https://abc.ordbogen.com/download-exam-information?mtm_campaign=exam-2025&mtm_kwd=ordbogen-banner"
      target="_blank"
      class="link"
      >Hent <span class="le-exam-banner__bold">opdateret</span> PDF</a
    >
  </LeTopBanner>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-exam-banner {
  &__bold {
    font-weight: bold;
  }
}
</style>
